<script setup lang="ts">
import type { IconGridBlock } from '~/types/storyblok/icon-grid-block'

const props = defineProps<{ blok: IconGridBlock }>()
const isContentCentered = computed(() => props.blok.cards.length === 1);
const columnWidth = useColumnWidth(props.blok.cards.length, props.blok.columns_on_mobile);
</script>

<template>
    <section class="icon-grid-block">
        <h2 v-if="blok.heading" class="heading">
            {{ blok.heading }}
        </h2>
        <div class="container"
            :style="{ '--phone-small': columnWidth.phoneSmall.value,'--phone': columnWidth.phone, '--phablet': columnWidth.phablet.value, '--laptop': columnWidth.laptop.value, '--desktop': columnWidth.desktop.value }">
            <IconGridCard v-for="item in blok.cards" :key="item._uid" :blok="item"
                :is-content-centered="isContentCentered" />
        </div>
    </section>
</template>

<style lang="scss" scoped>
@import 'assets/scss/rules/breakpoints';
@import 'assets/scss/typography/headings';


.heading {
    @include h6;
    text-align: center;

    @media screen and (min-width: $tablet) {
        @include h5;
    }
}

.container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 2rem 0rem 4rem;

    @media screen and (min-width: $tablet) {
        padding: 4rem 10rem 6rem;
    }
}
</style>
